import type { PropsWithChildren } from 'react';

interface FormControlProps {
  className?: string;
}

export const FormControl = ({
  className,
  children,
}: PropsWithChildren<FormControlProps>) => (
  <div className={['form-control', className].filter(Boolean).join(' ')}>
    {children}
  </div>
);
